import PropTypes from 'prop-types';

import YoutubeVideo from '../YoutubeVideo';

import style from './SliderTrackVideo.module.scss';

const SliderTrackVideo = ({ item, playing = false }) => (
  <div className={style['slider-video']}>
    <YoutubeVideo {...item} playing={playing} />
  </div>
);

SliderTrackVideo.propTypes = {
  item: PropTypes.shape(YoutubeVideo.propTypes).isRequired,
  playing: PropTypes.bool
};

export default SliderTrackVideo;
